export type ApplicationSubStatus = 'sent' | 'submitted'

/** Collected fee, shown beside progress when this application charges a fee. */
export type ApplicationFeeMark = 'paid' | 'unpaid'

export type ApplicationSubStatusTone = 'neutral' | 'good' | 'warn' | 'bad'

export interface ApplicationSubStatusDisplay {
    label: string
    tone: ApplicationSubStatusTone
}

export function getApplicationSubStatusDisplay(
    status: ApplicationSubStatus | 'paid' | null | undefined,
): ApplicationSubStatusDisplay {
    if (status == null) {
        return { label: 'Not sent', tone: 'neutral' }
    }
    switch (status) {
        case 'sent':
        case 'paid':
            return { label: 'In progress', tone: 'warn' }
        case 'submitted':
            return { label: 'Submitted', tone: 'good' }
        default:
            return { label: status, tone: 'neutral' }
    }
}

export function applicationFeeMark(params: {
    feeCents?: number | null
    paidAt?: string | null
    paymentStatus?: string | null
}): ApplicationFeeMark | null {
    if (params.feeCents == null || params.feeCents <= 0) return null
    const paid =
        params.paymentStatus === 'succeeded' ||
        (params.paidAt != null && params.paidAt !== '')
    return paid ? 'paid' : 'unpaid'
}
